<sm-container class="content">
  <h2 *ngIf="header" class="content__header">{{ header }}</h2>
  <div class="markdown">
    <div *ngFor="let item of splittedContent" [innerHTML]="item">
    </div>
  </div>
</sm-container>
